<template>
  <bg-style v-if="enabled" v-show="showActivity" v-imloading="loading" :is-disabled="$store.getters.isStandAloneMode" class="consecutive-widget" :class="isMobile ? 'activity_content_mobile relative' : 'activity_content_desk relative'" :bg="model.background" :mobile-bg="model.mobileBackground" :style="getStyle">
    <module-block :bg="model.background" :mobile-bg="model.mobileBackground" :max-content-width="1280">
      <div v-if="model.titleVisible" class="title relative" :class="className">
        <rich-text v-model="model.title" :force-wrap="hasHelpIcon" :editing="editing" :stroke.sync="model.titleStroke" :disabled="!editing" placement="bottom" theme="snow" />
        <img v-if="hasHelpIcon" class="cursor-pointer help-icon" :src="model.helpIcon.backgroundImage" alt="" @click="handleHelpClick">
      </div>
      <info-header :activity-data="activityData" :model="model" :current-number="currentNumber" :timeout-string="sTime" :has-recharge-amount="hasRechargeAmount" :min-daily-recharge-amount="minDailyRechargeAmount" :recharge-currency="rechargeCurrency" :currency-type="currencyType" :virtual-currency-logo="virtualCurrencyLogo" />
      <row-content v-if="model.layout === AccumulationLayoutEnum.Row" :site="site" :model="model" :editing="editing" :is-mobile="isMobile" :type="AccumulationLayoutEnum.Row" @show-loading="showLoading" @hide-loading="hideLoading" @show="onActivityShow" @end="onActivityEnd" @update-data="updateData" />
      <col-content v-else :model="model" :editing="editing" :is-mobile="isMobile" :site="site" :type="AccumulationLayoutEnum.Col" @show-loading="showLoading" @hide-loading="hideLoading" @show="onActivityShow" @update-data="updateData" />
      <div v-if="model.subtitleVisible" class="describe relative">
        <rich-text v-model="model.subtitle" :stroke.sync="model.subTitleStroke" :editing="editing" :disabled="!editing" placement="top" theme="snow" />
      </div>
    </module-block>
  </bg-style>
</template>

<script>
import RowContent from './rowContent.vue'
import ColContent from './colContent.vue'
import InfoHeader from './header.vue'
import { getTextColor, navTo } from '~/utils';
import richText from '~/components/richText'
import Bus from '~/site/model/bus'
import ModuleBlock from '~/components/common/ModuleBlock.vue'
import { AccumulationLayoutEnum } from "~/enums/data"

export default {
  name: 'ConsecutiveWidget',
  components: {
    ModuleBlock,
    richText,
    RowContent,
    ColContent,
    InfoHeader
  },
  props: {
    site: Object,
    model: {
      type: Object,
      default() {
        return {}
      },
    },
    editing: {
      type: Boolean,
      default: false,
    },
    device: {
      type: String,
      default: 'desktop',
    },
  },
  data() {
    return {
      showActivity: false,
      enabled: true,
      loading: false,
      AccumulationLayoutEnum,
      activityData: {},
      currentNumber: 0,
      sTime: '00:00:00',
      minDailyRechargeAmount: 0,
      hasRechargeAmount: 0,
      rechargeCurrency: null,
      currencyType: null,
      virtualCurrencyLogo: null,
      currencyLabel: ''
    }
  },
  computed: {
    hasHelpIcon() {
      return this.model.helpIcon?.backgroundImage && this.model.helpIcon?.backgroundImageShow
    },
    className() {
      const result = []
      if (!this.isMobile) {
        result.push('mb-[8px]')
      } else {
        result.push('mb-[4px]')
      }
      if (this.hasHelpIcon) {
        result.push('flex items-center')
      }
      return result
    },
    getStyle() {
      return {
        '--countdown-text-color': getTextColor(this.model.countdownTextColor).color,
        '--countdown-background': getTextColor(this.model.countdownBackgroundColor).color,
        '--card-radius': `${this.model.cardRadius}px`,
        '--card-shadow': `${this.model.cardShadow || 10}px`,
        '--text-color': getTextColor(this.model.textColor).color
      }
    },
    showTitle() {
      const res = this.model.layout.find((m) => {
        return m.key === 'activityTitle'
      })
      return res && res.value
    },
    isMobile() {
      return this.device === 'mobile'
    }
  },
  beforeDestroy() {
    Bus.$off('reloadActivity')
  },
  methods: {
    handleHelpClick() {
      if (this.editing) {
        return
      }
      navTo(this, this.model.nav)
    },
    onActivityShow() {
      this.showActivity = true
    },
    onActivityEnd() {
      this.enabled = false
      this.model.__hide = true
    },
    showLoading() {
      this.loading = true
    },
    hideLoading() {
      this.loading = false
    },
    updateData(data) {
      this.sTime = data.countdownText
      this.currentNumber = data.hasDay
      this.minDailyRechargeAmount = data.minDailyRechargeAmount
      this.hasRechargeAmount = data.hasRechargeAmount
      this.rechargeCurrency = data.rechargeCurrency
      this.currencyType = data.currencyType
      this.virtualCurrencyLogo = data.virtualCurrencyLogo
    }
  }
}
</script>

<style lang="less" scoped>
.consecutive-widget.activity_content_desk {
  padding: 20px 0;
  .help-icon {
    max-width: 40px;
    max-height: 40px;
    margin-left: 20px;
  }
  .describe {
    margin-top: 10px;
  }
}

.consecutive-widget.activity_content_mobile {
  padding: 10px;
  .help-icon {
    max-width: 30px;
    max-height: 30px;
    margin-left: 10px;
  }
  .title,
  .describe {
    padding: 0 5px;
  }
  .describe {
    margin-top: 10px;
  }
}
</style>
